import styled from "styled-components"
import { transparentize } from "polished"
import Image from "components/atoms/Image"

const StyledContainer = styled.div`
  width: auto;
  height: 5.8rem;
  display: flex;
  box-shadow: 0 0.2rem 0.4rem 0
    ${({ theme }) => transparentize(0.88, theme.color.main01)};
  background: ${({ theme }) => theme.color.white};
  transform: translateX(-50%);
  bottom: 1.4rem;
  position: absolute;
  padding: 1.2rem;
`
const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.2rem;
`
const StyledFirstLine = styled.div`
  display: flex;
  align-items: center;
`

const StyledIcon = styled(Image)`
  min-height: 3.2rem;
  width: auto;
  margin-left: 2rem;
  height: 100%;

  img {
    margin-left: 0;
  }
`
const StyledName = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.secondary01};
  white-space: nowrap;
`

const StyledTime = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.quinary03};
  margin-left: 0.4rem;
  white-space: nowrap;
`
const StyledRampInfo = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: 1rem;
  font-style: italic;
  line-height: 1.67;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.color.secondary02};
  align-items: center;
  display: flex;
  white-space: nowrap;
`
const StyledPointIcon = styled.img`
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 0.4rem;
`

const StyledLine = styled.span`
  display: block;
  position: absolute;
  left: 0.8rem;
  top: 0;
  width: 0.8rem;
  height: 5.8rem;

  ${({ color }) => color && `background: ${color}`}
`
export {
  StyledContainer,
  StyledContentContainer,
  StyledIcon,
  StyledName,
  StyledTime,
  StyledRampInfo,
  StyledFirstLine,
  StyledPointIcon,
  StyledLine,
}
